import {createSelector} from 'reselect';
import Immutable from 'seamless-immutable';

export const getConfirmRegistrationSelector = state => state.confirmRegistration;

export const getConfirmEmailSelector = createSelector(
    getConfirmRegistrationSelector,
    page => Immutable.asMutable(page.confirm, {deep: true})
);
